import { render, staticRenderFns } from "./qVirtualList.vue?vue&type=template&id=c974441c&scoped=true"
import script from "./qVirtualList.vue?vue&type=script&lang=js"
export * from "./qVirtualList.vue?vue&type=script&lang=js"
import style0 from "./qVirtualList.vue?vue&type=style&index=0&id=c974441c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c974441c",
  null
  
)

export default component.exports